<template>
    <div class="app-container">
        <main>
            <h1>Redirecting to Your Destination...</h1>
            <p>You will be redirected to:</p>
            <p style="font-size: 2.0rem">
                <a href="https://www.linkedin.com/in/whatley-julitar-4b2b17202/">LinkedIn/Whatley</a>
            </p>
            <p>in <span id="countdown">3</span> seconds.</p>
            <p>If you are not redirected, click the link above or use the button below.</p>
            <div class="spinner" role="status" aria-live="polite" aria-label="Loading..."></div>
            <div class="progress-bar"></div>
            <button class="redirect-btn" @click="manualRedirect">Redirect Now</button>
        </main>
    </div>
</template>

<script>
export default {
    data() {
        return {
            redirectUrl: "https://www.linkedin.com/in/whatley-julitar-4b2b17202/",
            countdown: 3,
            progress: 0,
            buttonDisabled: false,
            buttonLabel: "Redirect Now",
            intervalId: null,
            timeoutId: null,
        };
    },
    methods: {
        startCountdown() {
            this.intervalId = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                    this.progress += 100 / 3;
                } else {
                    clearInterval(this.intervalId);
                }
            }, 1000);

            this.timeoutId = setTimeout(() => {
                this.redirect();
            }, 3000);
        },
        redirect() {
            window.location.href = this.redirectUrl;
        },
        manualRedirect() {
            this.buttonDisabled = true;
            this.buttonLabel = "Redirecting...";
            this.redirect();
        },
    },
    mounted() {
        this.startCountdown();
    },
    beforeUnmount() {
        clearInterval(this.intervalId);
        clearTimeout(this.timeoutId);
    },
};
</script>


<style scoped>
.app-container {
    height: 95vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f3f6f8;
    /* Light grey background similar to LinkedIn's */
    margin: 0;
}

main {
    background-color: white;
    /* White background for content */
    border-radius: 10px;
    padding: 40px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    max-width: 500px;
    width: 90%;
    text-align: center;
    position: relative;
    animation: fadeIn 1s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.9);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

h1 {
    font-size: 2rem;
    margin-bottom: 1rem;
    font-weight: bold;
    color: #0077b5;
    /* LinkedIn's signature blue */
}

p {
    font-size: 1rem;
    margin-bottom: 1rem;
    line-height: 1.6;
    color: #555;
    /* Dark grey for text */
}

a {
    color: #0077b5;
    /* LinkedIn's signature blue */
    text-decoration: none;
    font-weight: bold;
    transition: color 0.3s ease;
}

a:hover {
    color: #005c8a;
    /* Darker blue on hover */
}

.spinner {
    margin: 20px auto;
    width: 50px;
    height: 50px;
    border: 6px solid rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    border-top: 6px solid #0077b5;
    /* LinkedIn's blue for spinner */
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.progress-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 5px;
    background-color: #0077b5;
    /* LinkedIn's blue for progress bar */
    animation: progress 3s linear forwards;
}

@keyframes progress {
    0% {
        width: 0%;
    }

    100% {
        width: 100%;
    }
}

.redirect-btn {
    background-color: #0077b5;
    /* LinkedIn blue */
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: bold;
    margin-top: 20px;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

.redirect-btn:hover {
    background-color: #005c8a;
    /* Darker blue on hover */
    transform: translateY(-2px);
}

.redirect-btn:disabled {
    background-color: #b0b0b0;
    /* Disabled button in grey */
    cursor: not-allowed;
}

@media (max-width: 600px) {
    h1 {
        font-size: 1.5rem;
    }

    p {
        font-size: 0.9rem;
    }

    .spinner {
        width: 40px;
        height: 40px;
        border-width: 5px;
    }
}
</style>
